import { IUserUpdateSingleArgs } from "../interfaces/IUpdateSingleArgs";

export default function mapUserUpdateArgs(userEditItem: any): IUserUpdateSingleArgs {
    const userUpdateArgs: IUserUpdateSingleArgs = {
        email_address: userEditItem.email_address,
        first_name: userEditItem.first_name,
        last_name: userEditItem.last_name,
        awayz_access: userEditItem.awayz_access,
        password_reset: userEditItem.password_reset,
        partner_primary_category: userEditItem.partner_primary_category,
        partner_secondary_category: userEditItem.partner_secondary_category,
        admin_right: userEditItem.admin_right,
        influencer_links: userEditItem.influencer_links,
        user_roles: userEditItem.user_roles,
        source: userEditItem.source,
        userRegion: userEditItem.userRegion,
        emailVerified: userEditItem.email_verified
    };

    if (!userUpdateArgs.partner_primary_category) {
        delete userUpdateArgs.partner_primary_category;
    }
    
    if (!userUpdateArgs.partner_secondary_category) {
        delete userUpdateArgs.partner_secondary_category;
    }

    return userUpdateArgs;
}